(function ($) {

   const container = $('section#reviews .reviews-container');
   const mask = $('section#reviews .reviews-mask');

   const reviews = $('section#reviews .review');
   const first = reviews.first();
   const last = reviews.last();

   let len = reviews.length + 2;
   let index = 1;

   let startX, startLeft, endX;
   let isDragging = false;





   container.on('mousedown', (e) => {
      startX = e.clientX;
      startLeft = parseFloat(container.css('left'));

      container.removeClass('slide');
      isDragging = true;
   });

   container.on('mousemove', (e) => {
      if (isDragging) {
         container.css('left', `${startLeft + (e.clientX - startX)}px`);
      }
   });

   container.on('mouseup', (e) => {

      isDragging = false;
      endX = e.clientX;
      const direction = startX > endX ? 'next' : 'prev';
      const threshold = 100;
      const calc = Math.abs(startX - endX);

      if (calc > threshold ) {

         container.addClass('slide');
         slideItem(direction);

      } else {

         container.addClass('slide');
         container.css('left', `-${index * 100}%`);
      }

      // console.log(direction, calc, threshold);

   });

   const slideItem = direction => {

      container.addClass('slide');

      var limit = len - 2;

      if (direction === 'next') {
         if (index !== limit) {
            index++;
            container.css('left', `-${index * 100}%`);
         } else {

            container.css('left', `-${(len - 1) * 100}%`);
            index = 1;

            //    setTimeout(() => {
            //       container.removeClass('slide');
            //       container.css('left', `-${index * 100}%`);
            //   }, 500);

         }
      } else {

         if (index > 1) {

            index--;
            container.css('left', `-${index * 100}%`);

         } else {

            container.css('left', `-${0}%`);
            index = limit;

            // setTimeout(() => {
            //     container.removeClass('slide');
            //     container.css('left', `-${index * 100}%`);
            // }, 500);

         }
      }

      setTimeout(() => {
         container.removeClass('slide');
         container.css('left', `-${index * 100}%`);
         $('section#reviews .next, section#reviews .prev').removeClass('disabled');
      }, 500);

   };

   $('section#reviews .prev').click(() => {

      slideItem('prev');
      $('section#reviews .prev').addClass('disabled');


   });

   $('section#reviews .next').click(() => {

      slideItem('next');
      $('section#reviews .next').addClass('disabled');


   });

   $(document).ready(() => {

      last.clone().insertBefore(first).css('width', `${100 / len}%`);
      first.clone().insertAfter(last).css('width', `${100 / len}%`);

      container.css('width', `${100 * len}%`);
      reviews.css('width', `${100 / len}%`);

      container.css('left', '-100%');
      mask.css('height', container.height());

   });

   $(window).on('resize', () => {
      mask.css('height', container.height());
   });

})(jQuery)
